import { useContext } from "react"
import styled from "styled-components"
import { Container, Section, TitleWrapper } from "components/styled/Grid"
import { useT } from "react-polyglot-hooks"
import Typography from "components/styled/Typography"
import FaqList from "components/FaqList"
import { EmployeeContext } from "../EmployeeContext"

const Background = styled(Section)`
  background-color: ${({ theme }) => theme.colors.lightGray};
  border-top: 1px solid ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.white};
`

export default function Faq() {
  const t = useT()
  const { faqs } = useContext(EmployeeContext)

  return (
    <Background>
      <Container>
        <TitleWrapper>
          <Typography variant="title2" weight="bold" center space>
            {t("common.faqs")}
          </Typography>
        </TitleWrapper>
        <FaqList list={faqs} page="employee" />
      </Container>
    </Background>
  )
}
